import { Component } from '@angular/core';

@Component({
  selector: 'lib-feature-admin-data-access',
  imports: [],
  templateUrl: './feature-admin-data-access.html',
  styleUrl: './feature-admin-data-access.css',
})
export class FeatureAdminDataAccess {}
